import { InjectionToken, Type } from '@angular/core';

export interface ReportParamsComponent {
  variables: Record<string, unknown>;
  selectionChanged?: (variables: Record<string, unknown>) => void;
}

export interface ReportParams {
  readonly reportTemplateId: string;
  readonly component: Type<ReportParamsComponent>;
}

export const REPORT_PARAMS = new InjectionToken<ReportParams[]>('REPORT_VARIABLES');
